<template>
  <div class="logo-container" data-aos="fade-up" data-aos-offset="0">
    <transition name="fadeIn1">
      <img src="@/assets/topLogo.svg" alt="topLogo" />
    </transition>
    <transition name="fadeIn1">
      <p class="date-text text24">24.04.2023 — 28.04.2023</p>
    </transition>
  </div>
</template>

<script>
import AOS from 'aos';
import { mapState } from 'vuex';

export default {
  name: 'Top',
  computed: mapState(['showPreloader']),
  mounted() {
    let scrollRef = 0;
    const aosListener = () => {
      if (window.innerWidth > 768) {
        scrollRef <= 10 ? scrollRef++ : AOS.refresh();
        scrollRef++;
        if (scrollRef > 100) {
          window.removeEventListener('scroll', aosListener);
        }
      } else {
        scrollRef <= 300 ? scrollRef++ : AOS.refresh();
        scrollRef++;
        if (scrollRef > 500) {
          window.removeEventListener('scroll', aosListener);
        }
      }
    };
    window.addEventListener('scroll', aosListener);
  }
};
</script>

<style lang="scss" scoped>
.logo-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo-container > img {
  width: 61.5rem;
}

.date-text {
  margin-top: 6.5rem;
}

@media screen and (max-width: 768px) {
  .logo-container {
    height: 51.875rem;
  }

  .date-text {
    margin-top: 8rem;
  }

  .logo-container > img {
    padding-top: 10rem;
    width: 72rem;
  }
}
</style>
